



















































































import Vue from "vue";
import TableLayout from "@/layouts/TableLayout.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import { Header } from "@/components/MyTable.vue";
import { axios } from "@/plugins";

const TableHeader: Header[] = [
  { title: "操作人", key: "optUser", width: 140 },
  { title: "IP", key: "ip", width: 170 },
  { title: "操作类型", key: "optType", width: 120 },
  { title: "系统模块", key: "sysModel", width: 150 },
  { title: "参数", key: "params", width: 180 },
  { title: "方法", key: "method", width: 180 },
  { title: "描述", key: "description", minWidth: 400 },
  { title: "操作时间", key: "createTime", width: 200 }
];
export default Vue.extend({
  name: "OperationLog",
  components: { TableLayout },
  data() {
    return {
      disabled: false,
      optTypeOptions: [],
      sysModelOptions: [],
      TableHeader,
      form: {
        optType: "",
        optUser: "",
        sysModel: ""
      }
    };
  },
  computed: {
    ...mapState("OperationLog", ["total", "hasNext", "pageNum", "loading"]),
    ...mapGetters("OperationLog", ["tableData"])
  },
  mounted() {
    this.getCindition();
    this.getTable();
  },
  methods: {
    ...mapActions("OperationLog", [
      "getData",
      "pageTurn",
      "filterSearch",
      "clear"
    ]),
    getCindition() {
      axios.get(`/sysoptlog/conditions`).then(res => {
        this.optTypeOptions = res.data.data.optTypeList;
        this.sysModelOptions = res.data.data.sysModelList;
      });
    },
    getTable() {
      this.getData({
        url: `/sysoptlog`,
        append: `&optType=${this.form.optType}&sysModel=${this.form.sysModel}&optUser=${this.form.optUser}`
      });
    },
    turnPage(page: number) {
      this.disabled = true;
      this.pageTurn({ page }).finally(() => {
        this.disabled = false;
      });
    },
    search() {
      (this.$refs.MyTable as any).clear();
      this.filterSearch({
        url: `/sysoptlog`,
        append: `&optType=${this.form.optType}&sysModel=${this.form.sysModel}&optUser=${this.form.optUser}`
      });
    }
  }
});
